interface Fact {
  label: string
  value: string
}

/** Company facts as a hairline-divided strip: mono labels over plain values. */
export function AboutFactStrip({ facts }: { facts: ReadonlyArray<Fact> }) {
  return (
    <dl className="grid grid-cols-1 divide-y divide-[var(--color-border)] border-y border-[var(--color-border)] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
      {facts.map((fact) => (
        <div
          key={fact.label}
          className="min-w-0 py-6 sm:px-6 sm:first:pl-0 sm:last:pr-0"
        >
          <dt className="eyebrow text-[11px]">{fact.label}</dt>
          <dd className="mt-3 break-words text-lg font-medium tracking-[-0.01em] text-[var(--color-text-primary)]">
            {fact.value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
